import { History } from "history";
import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { Dispatch } from "redux";

import { canUseMyzToken } from "../../store/selectors";
import { goToPage } from "../../../utils/tools";

type Props = {
  history: History;
  userIsSubscribed: null | boolean;
  wotdFormSubmitSuccess: null | boolean;
  wotdPresetSuccess: null | boolean;
  wotdPresetError: null | Error;
  confirmError: null | Error;
  canUseMyzToken: boolean;
};

type State = {};

class Redirector extends React.Component<Props, State> {
  public readonly state: State = {};

  componentDidUpdate(prevProps: Props) {
    const { history } = this.props;

    if (
      this.props.userIsSubscribed === false &&
      this.props.userIsSubscribed !== prevProps.userIsSubscribed
    ) {
      // grigio --> arancione
      goToPage("/iscrizione", history);
    } else if (
      this.props.userIsSubscribed === true &&
      this.props.userIsSubscribed !== prevProps.userIsSubscribed &&
      !this.props.canUseMyzToken
    ) {
      // grigio --> azzurro (pesce palla)
      goToPage("/gestione/identificazione", history);
    } else if (
      this.props.userIsSubscribed === true &&
      this.props.userIsSubscribed !== prevProps.userIsSubscribed &&
      this.props.canUseMyzToken
    ) {
      // grigio --> rosa (squalo)
      goToPage("/gestione", history);
    } else if (
      !this.props.wotdPresetSuccess &&
      this.props.wotdFormSubmitSuccess === true &&
      this.props.wotdFormSubmitSuccess !== prevProps.wotdFormSubmitSuccess &&
      !this.props.userIsSubscribed &&
      !this.props.canUseMyzToken
    ) {
      // arancione --> azzurrino (pesce palla)
      goToPage("/iscrizione/attesa", history);
    } else if (
      this.props.wotdFormSubmitSuccess === true &&
      this.props.wotdFormSubmitSuccess !== prevProps.wotdFormSubmitSuccess &&
      !this.props.userIsSubscribed &&
      this.props.canUseMyzToken
    ) {
      // arancione --> giallo (squalo)
      goToPage("/iscrizione/conferma", history);
    } else if (
      this.props.wotdPresetSuccess === true &&
      this.props.wotdFormSubmitSuccess === true &&
      this.props.wotdFormSubmitSuccess !== prevProps.wotdFormSubmitSuccess
    ) {
      // rosa --> verde
      goToPage("/gestione/conferma", history);
    } else if (
      this.props.wotdPresetError &&
      JSON.stringify(this.props.wotdPresetError) !==
        JSON.stringify(prevProps.wotdPresetError)
    ) {
      // rosa --> errore (pesce palla)
      goToPage("/errore", history);
    } else if (
      this.props.confirmError &&
      JSON.stringify(this.props.confirmError) !==
        JSON.stringify(prevProps.confirmError)
    ) {
      // giallo --> errore (pesce palla)
      goToPage("/errore", history);
    }
  }

  render() {
    return null;
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    userIsSubscribed: state.subscriptionemail.isSubscribed,
    wotdFormSubmitSuccess: state.wotdformdata.loaded,
    wotdPresetSuccess: state.wotdpreset.loaded,
    wotdPresetError: state.wotdpreset.error,
    confirmError: state.confirm.error,
    canUseMyzToken: canUseMyzToken(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Redirector);
